import * as styles from './NewsboardList.module.css'

function NewsboardList({ children }) {
  return <div className={styles.NewsboardList}>{children}</div>
}

export default NewsboardList
